export function toSeatCount(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric < 0) return 0;
  return Math.floor(numeric);
}

export function packageSeatSummary(pkg = {}) {
  const total = toSeatCount(
    pkg.configuredCapacity ?? pkg.configured_capacity ?? pkg.seats ?? pkg.u_pkg_seats
  );
  const booked = toSeatCount(pkg.bookedSeats ?? pkg.booked_seats);
  const availableRaw = pkg.availableSeats ?? pkg.available_seats;
  const available = availableRaw == null || availableRaw === ""
    ? Math.max(0, total - booked)
    : toSeatCount(availableRaw);
  const soldOut = Boolean(pkg.soldOut) || available <= 0;

  return {
    total,
    booked,
    available,
    soldOut,
    label: total ? `${available} / ${total}` : (available ? String(available) : "Not set"),
  };
}
